import { render } from "./AddEditSkillsMatrix.vue?vue&type=template&id=10881f1a&ts=true"
import script from "./AddEditSkillsMatrix.vue?vue&type=script&lang=ts"
export * from "./AddEditSkillsMatrix.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../sf-playbook-app/APP/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__